import React from 'react'

export default function VisiGiftBrochureDownloadHistory() {
  return (
    <div>VisiGiftBrochureDownloadHistory</div>
  )
}
